import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const ListItem = ({
	label = '',
	controlTitleField = 'title',
	maxTitleLength,
	options = [],
	valueField = 'name',
	selectedValue = '',
	selectedOption,
	resetOption = { title: 'Показать все', name: '' },
	resetOneFilter,
	name = '',
	defaultFiltersValues,
	switchFilter,
	tempLocalOption
}) => {
	const resultSelectedOption = !_.isEmpty(selectedOption)
		? selectedOption
		: (() => {
				if (tempLocalOption) {
					return tempLocalOption;
				}
				let res = _(options).findWhere({
					[valueField]: String(selectedValue)
				});

				if (name === 'tags') {
					res = _(options).findWhere({
						[valueField]: selectedValue
					});
				}

				if (name === 'locale') {
					res = options.length === 1 ? options[0] : resetOption;
				}

				if (!res) {
					res = resetOption;
				}

				return res;
		  })();

	let title = resultSelectedOption[controlTitleField];

	if (maxTitleLength && title.length > maxTitleLength * 1.2) {
		title = `${title.slice(0, maxTitleLength)}...`;
	}

	const resetOneHandler = (event) => {
		const maxPriceDefaultValue = 5000;

		if (
			(selectedValue && name !== 'maxPrice' && selectedValue !== 'russia') ||
			(name === 'maxPrice' && selectedValue !== maxPriceDefaultValue)
		) {
			event.stopPropagation();
			resetOneFilter(name);
		}
	};

	const tempValue = tempLocalOption?.value;
	const anyExistringValue = tempValue || selectedValue;

	const showCloseIcon =
		anyExistringValue && anyExistringValue !== defaultFiltersValues[name];

	const handleItemClick = () => {
		switchFilter({ label, value: selectedValue, name }, true);
	};

	return (
		// eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
		<div role="button" onClick={handleItemClick} className={styles.ListItem}>
			<div className={styles.ListItem__Header}>
				<span className={styles.ListItem__Label}>{label}</span>
				<span className={styles.ListItem__Title}>{title}</span>
			</div>
			<button
				onClick={showCloseIcon ? resetOneHandler : handleItemClick}
				type="button"
				className={styles.ListItem__Button}
			>
				<Icon
					icon={showCloseIcon ? 'close' : 'arrow-down'}
					className={
						showCloseIcon
							? styles.ListItem__CloseIcon
							: styles.ListItem__ButtonIcon
					}
				/>
			</button>
		</div>
	);
};

ListItem.propTypes = {
	resetOption: PropTypes.shape({
		title: PropTypes.string.isRequired,
		name: PropTypes.string
	}),
	controlTitleField: PropTypes.string,
	label: PropTypes.string,
	name: PropTypes.string,
	resetOneFilter: PropTypes.func,
	defaultFiltersValues: PropTypes.object,
	maxTitleLength: PropTypes.number,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			name: PropTypes.string
		})
	),
	valueField: PropTypes.string,
	selectedValue: PropTypes.node,
	selectedOption: PropTypes.shape({
		title: PropTypes.string,
		name: PropTypes.string
	}),
	switchFilter: PropTypes.func,
	tempLocalOption: PropTypes.shape({
		title: PropTypes.string,
		name: PropTypes.string,
		value: PropTypes.string
	})
};

export default ListItem;
